// src/nova-eventing.interface.ts
var InputType = {
  unknown: "unknown",
  mouse: "mouse",
  keyboard: "keyboard",
  touch: "touch",
  pen: "pen",
  programmatic: "programmatic"
};
export {
  InputType
};
